// extracted by mini-css-extract-plugin
export default {"title":"WidgetShortestQueue_title__6HGny","button":"WidgetShortestQueue_button__Sk33b"};